(() => {
  const template = () => document.getElementById('cc4-cart-trust-template');

  const enhanceCart = (root = document) => {
    const tpl = template();
    if (!(tpl instanceof HTMLTemplateElement)) return;

    root.querySelectorAll('.cart__ctas').forEach((ctas) => {
      if (ctas.querySelector('[data-cc4-cart-enhancement]')) return;
      ctas.appendChild(tpl.content.cloneNode(true));
    });

    root.querySelectorAll('.cart__checkout-button').forEach((button) => {
      if (button.dataset.cc4Enhanced === 'true') return;
      button.dataset.cc4Enhanced = 'true';
    });
  };

  const start = () => {
    enhanceCart(document);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('.cart__ctas, cart-items-component, .cart-drawer__summary, .cart-page__summary')) {
            enhanceCart(node.parentElement || document);
          } else if (node.querySelector?.('.cart__ctas')) {
            enhanceCart(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();